import React from "react";

import { Grid, Box } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

const RecipeLoading: React.FC = () => {
  return (
    <>
      <Grid container spacing={3} direction="column">
        {[...Array(10)].map((_, index) => (
          <Grid item xs={12} key={index}>
            <Box display="flex" alignItems={"center"} mb={2}>
              <Box marginRight={4}>
                <Skeleton variant="circular" width={40} height={40} />
              </Box>
              <Skeleton variant="text" width={150} height={32} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={1} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default RecipeLoading;
